// import dialogs from "../dialogs";
import notificationMessages from "../notificationMessages";
import ServerErrorLog from "../serverErrorLog";
import uiStateOperations from "./uiState/actions";

/* eslint-disable no-console */

// When we catch an error, we want to do the following:
// 1) Log the error to console (for debugging)
// 2) Log the error to Sentry
// 3) Fallback to the previous state, but attempt to show an error message to the user
export const handleErrorInReducer = (reducer, incomingState, action, origError) => {
  let finalState = incomingState;

  try {
    // Log error to console
    console.error(
      `Caught error inside a reducer responding to action of type ${
        action && action.type ? action.type : "null"
      }. The error, incomingState, and action are printed below`
    );
    console.dir(origError);
    console.dirJs(incomingState);
    console.dirJs(action);

    // Log the error to Sentry
    ServerErrorLog.sendError(origError);

    // Now fallback to the incoming state but try to show an error message
    if (reducer) {
      const showErrorAction = uiStateOperations.addNotification(notificationMessages.reducerErrorNotification);
      finalState = reducer ? reducer(incomingState, showErrorAction) : incomingState;
    } else {
      console.error(`REDUCER WAS NULL, so nothing can be shown`);
      // dialogs.alertPrompt("We were unable to perform that action.", null, "Something went wrong!");
    }
  } catch (err) {
    // We cannot show the error message nicely, so show it badly
    // dialogs.alertPrompt("We were unable to perform that action.", null, "Something went wrong!");
    console.error(`Caught error in handleError(): could not run new reducer or something?`);

    finalState = incomingState;
  }

  return finalState;
};

export const sendCustomError = (obj, origError) => {
  try {
    // Log error to console
    console.error(`Caught custom error`);
    console.dir(origError);
    console.dir(obj);

    // Log the error to Sentry
    ServerErrorLog.sendError(obj);
  } catch (err) {
    console.error(`Caught error in sendCustomError()`);
  }
};

export default reducer => {
  // Try to run the reducer, but handle the error if it fails
  return function(incomingState, action) {
    let finalState = incomingState;
    try {
      finalState = reducer(incomingState, action);
    } catch (err) {
      finalState = handleErrorInReducer(reducer, incomingState, action, err);
    }
    return finalState;
  };
};
